import { render, staticRenderFns } from "./BibleRecords.vue?vue&type=template&id=403f1306&"
import script from "./BibleRecords.vue?vue&type=script&lang=js&"
export * from "./BibleRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports